import Reflux from 'reflux';
import { Map, List, fromJS } from 'immutable';
import BaseMixin from 'flux/stores/BaseMixin';
import CuesheetCellLinkActions from 'flux/actions/cuesheet/CuesheetCellLinkActions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import EventViewStore from 'flux/stores/EventViewStore';
import ModalStore from 'flux/stores/ModalStore';

/**
 * Cuesheet Cell Link Store
 *
 */
export default Reflux.createStore({
  listenables: [CuesheetCellLinkActions],

  mixins: [BaseMixin],

  init() {
    this._initState();

    this.listenTo(EventViewStore, this.onEventChange);
    this.listenTo(ModalStore, this.onModalChange);
  },

  _initState() {
    this._docPage = 1;
    this._term = undefined;

    this.setState(this._getInitState());
  },

  _getInitState() {
    return Map({
      activeMode: 'external',
      docs: List(),
      corruptedCells: Map(),
    });
  },

  onModalChange() {
    //Re init when modal state changes
    this._initState();
  },

  onEventChange(event) {
    this._teamId = event.get('team');
    this._eventId = event.get('_id');

    this._initState();
  },

  onSetActiveMode(mode) {
    this.setInStateAndTrigger('activeMode', mode);

    if (mode === 'doc') {
      CuesheetCellLinkActions.setDocSearchTerm(
        this._teamId,
        this._eventId,
        this._term,
      );
    }
  },

  onUpdateDocSearchTerm(term) {
    CuesheetCellLinkActions.setDocSearchTerm(this._teamId, this._eventId, term);
  },

  onSetDocSearchTerm(teamId, eventId, term) {
    if (term !== this._term) {
      this._term = term;

      this._docPage = 1;
      this.setInState('docs', List());
      this.setInState('docCount', 0);
    }

    this.setInStateAndTrigger('loadingDocs', true);
  },

  onSetDocSearchTermCompleted(results) {
    /**
     * If the term has changed before results come back, disregard
     */
    if (results.term != this._term) return;

    this.setStateAndTrigger(
      this.getState()
        .set('loadingDocs', false)
        .update('docs', (docs) => docs.concat(fromJS(results.items)))
        .set('docCount', fromJS(results.itemCount)),
    );
  },

  onLoadMoreDocs() {
    if (this.getInState('docs').size >= this.getInState('docCount')) {
      return;
    }

    this._docPage = this._docPage + 1;

    CuesheetCellLinkActions.setDocSearchTerm(
      this._teamId,
      this._eventId,
      this._term,
      this._docPage,
    );
  },

  onSelectDocForInsert(docId) {
    this.setInStateAndTrigger('selectedDocId', docId);
  },

  onSaveSelectedDocLink() {
    let doc = this.getInState('docs').find(
      (doc) => doc.get('_id') === this.getInState('selectedDocId'),
    );

    let text = doc.get('name');
    let link = `/teams/${this._teamId}/events/${this._eventId}/doc/${doc.get(
      '_id',
    )}`;

    CuesheetCellActions.saveSelectedCellTextWithLink(text, link);
  },
});
